import React, { useState } from "react";
import MUIRichTextEditor from "mui-rte";

import { createTheme, ThemeProvider } from "@mui/material";
import { stateToHTML } from "draft-js-export-html";
import { stateFromHTML } from "draft-js-import-html";
import { convertToRaw } from "draft-js";
import TMUIRichTextEditorRef from "mui-rte";

const defaultTheme = createTheme();
Object.assign(defaultTheme, {
  overrides: {
    MUIRichTextEditor: {
      root: {
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.06)",
        height: "162px",
        padding: "0 12px",
        overflowY: "scroll",
        "&::-webkit-scrollbar": {
          width: "5px",
        },

        /* Track */
        "&::-webkit-scrollbar-track": {
          background: "rgba(0, 0, 0, 0.16)",
          display: "none",
        },

        /* Handle */
        "&::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: "5px",
        },

        /* Handle on hover */
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#555",
          borderRadius: "5px",
        },
      },
      editor: {
        //borderBottom: "1px solid gray",
      },
    },
  },
});

const index = ({ formik, name, controls, ...rest }) => {
  const state = stateFromHTML(formik.values[name]);
  const contentState = JSON.stringify(convertToRaw(state));
  const content = contentState;
  const [temp, setTemp] = useState(content)
  return (
    <div>
      <ThemeProvider theme={defaultTheme}>
        <MUIRichTextEditor
          id={name}
          {...rest}
          defaultValue={temp}
          ref={TMUIRichTextEditorRef}
          inlineToolbar={false}
          controls={controls}
          onChange={(e) => {
            const htmlString = stateToHTML(e.getCurrentContent());
            formik.setFieldValue(name, htmlString);
          }}
        />
        {formik.errors[name] && formik.touched[name] && (
          <p
            style={{
              color: "#d32f2f",
              fontFamily: '"Roboto","Helvetica","Arial","sans-serif"',
              fontWeight: 400,
              lineHeight: 1.66,
              letterSpacing: "0.03333em",
              textAlign: "left",
            }}
          >
            {formik.errors[name]}
          </p>
        )}
      </ThemeProvider>
    </div>
  );
};

export default index;
